<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { fade } from 'svelte/transition';
    import { fetchData } from '../../shared/utils/Data.svelte';
    import { sortByName, ignoreCaseSort, projectSort } from '../../shared/utils/Sort.svelte';
    import { addCircleOutline, settings, trash, link, bookmark, image, refresh, headset, videocam, document, book } from 'ionicons/icons/index.mjs';

    export let role;
    export let feature;
    export let layer;
    export let session;
    let history = [];

    const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
    }

    onMount(async () => {
        if (feature && layer && layer.metadata) {
            let [res, err]  = await fetchData("/v1/history/" + feature.properties[layer.metadata["geosync:id"]], {
                headers: {
                    'Authorization': 'Bearer ' + session.token
                }
            });
            if (err) {
                console.log(err);
                return;
            }
            history = res.data.history;
        }
    });
</script>

<div id="stage" in:fade>
    {#if history.length > 0}
        {#each history as item}
            <ul class="menu menu-nav" in:fade>
                <div class="tile tile-centered">
                    <div class="tile-content">
                        <li class="menu-item">
                            <button class="btn btn-link"
                            on:click|stopPropagation={(e) => {
                                e.currentTarget.blur();
                                sendMessage({
                                    type: "modal",
                                    data: {
                                        view: "history",
                                        history: item,
                                        feature: feature,
                                        layer: layer,
                                        role: role
                                    }
                                })
                            }}>{item.name}</button>
                        </li>
                    </div>
                </div>
            </ul>
        {/each}
    {:else}
        <div class="empty">
            <div class="empty-icon">
                <i class="svg">{@html book.md}</i>
            </div>
            <p class="empty-title h5">No history data</p>
        </div>
    {/if}
</div>

<style>
    .menu {
        padding: 0;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
        border: 0;
        padding: 0.4rem 0.8rem;
	}
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .empty .empty-icon {
        width: 150px;
        margin: auto;
    }
    .empty .empty-title {
        margin-top: 0;
        color: black;
    }
</style>